import TagManager from 'react-gtm-module';
import { getMainEvent, getSelectedEvent, isSeries } from "@b/checkout/selectors/event";
import withCurrencyConfig from "@c/WithCurrencyConfig";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as hookActions from 'checkout/actions/hooks';

const nullFallback = 'Not Set';

export class CustomGTM extends Component {
  constructor(props) {
    super(props);

    this.props.addReservationCompleteHook(this.onReservationComplete);
  }

  report = (dataLayer, analyticContainer = false) => {
    TagManager.dataLayer({ dataLayer });

    analyticContainer && this.pushToAnalyticsContainer(dataLayer);
  }

  pushToAnalyticsContainer = (data) => {
    this.props.reportEvent('custom-gtm')(data);
  }

  onReservationComplete = () => {
    const reservationSessionKey = `CustomGTM_onReservationComplete_${this.props.confirmationNumber}`;
    const sent = sessionStorage.getItem(reservationSessionKey);

    if (!sent) {
      const dataLayer = {
        event: 'event_registration',
        event_reg_name: this.props.mainEvent?.name || nullFallback,
        event_reg_series: this.props.listingSlug,
        event_platform: this.props.isSeries ? this.props.mainEvent?.event_id : nullFallback,
        event_reg_id: this.props.selectedEvent?.event_id || nullFallback,
        venue_location: this.props.selectedVenueId || nullFallback,
        location_id: this.props.selectedVenueId || nullFallback, 
        location_detail: this.props.selectedVenueId || nullFallback,
        quantity: this.props.reservation?.items_count || nullFallback
      }
  
      this.report(dataLayer, true);

      sessionStorage.setItem(reservationSessionKey, '1');
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  const mainEvent = getMainEvent(state)?.event;
  const selectedEvent = getSelectedEvent(state)?.event;
  const selectedVenue = getSelectedEvent(state)?.venue;

  return {
    mainEvent: mainEvent ?? null,
    selectedEvent: selectedEvent ?? null,
    selectedVenueId: selectedVenue?.venue_id ? Number(selectedVenue.venue_id) : null,
    isSeries: isSeries(state),
    listingSlug: state.ui.listingSlug,
    reservation: state.reservation,
    confirmationNumber: state.reservation.confirmation_number,
  };
};

const mapDispatchToProps = dispatch => {
    const actions = {};
    Object.keys(hookActions).forEach(hookActionName => {
        actions[hookActionName] = hookActions[hookActionName];
    });
    return bindActionCreators(actions, dispatch);
}

export default withCurrencyConfig(connect(mapStateToProps, mapDispatchToProps)(CustomGTM));
